/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'semantic-ui-react';

// expected props
// currentStep an instance of the CurrentStep model
const Component = observer(({ currentStep = {}, envTypeImmutable = false }) => {
  let activeIndex;
  const step = currentStep.step;

  switch (step) {
    case 'selectComputePlatform':
    case 'selectEnvType':
      activeIndex = 1;
      break;
    case 'selectComputeConfiguration':
    case 'selectEnvConfig':
      activeIndex = 2;
      break;
    default:
      activeIndex = 0;
  }

  const steps = [
    { label: 'Select Studies', icon: 'search' },
    ...(!envTypeImmutable ? [{ label: 'Select Software', icon: 'server' }] : []),
    { label: 'Configure Workspace', icon: 'hdd outline' },
  ];

  // Adjust activeIndex if envTypeImmutable removes step 1
  const adjustedIndex = envTypeImmutable && activeIndex > 0 ? activeIndex - 1 : activeIndex;

  return (
    <div className="modern-steps">
      {steps.map((s, i) => {
        const isCompleted = i < adjustedIndex;
        const isActive = i === adjustedIndex;
        const circleClass = isCompleted ? 'completed' : isActive ? 'active' : 'inactive';
        const labelClass = circleClass;

        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <div className={`modern-step-connector ${isCompleted || isActive ? 'completed' : 'inactive'}`} />
            )}
            <div className="modern-step">
              <div className={`modern-step-circle ${circleClass}`}>
                {isCompleted ? <Icon name="check" style={{ margin: 0, lineHeight: 1, height: '1em' }} /> : i + 1}
              </div>
              <span className={`modern-step-label ${labelClass}`}>{s.label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
});

export default Component;
